/* eslint-disable @typescript-eslint/camelcase */
import { FormModelProps } from 'modules/environments/interfaces';

export const initial: FormModelProps = {
  name: '',
  description: '',
  cpu_weight: 0,
  memory_weight: 0,
  connection_weight: 100,
  cpu_max: 100,
  memory_max: 100,
  connection_max: 100,
  temperature_empty: 0,
  temperature_stopped: 0,
  temperature_operational: 0,
  temperature_top: 100,
  boot_time: 180,
  provider_data: {
    image_id: '',
    primary_zone: '',
    secondary_zone: '',
    security_group: '',
    zone: '',
    subnet: '',
    key_pair: '',
    flavor: '',
    is_spot: false,
    credit_specifications: '',
    boot_volume_id: '',
    boot_volume_backup_id: '',
    license_type: null,
  },
};
